import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/PartSearchResultsData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class PartSearchResultsDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "PartSearchResultsDataStore",
			variables: false,
		})
	}
}

export async function load_PartSearchResultsData(params) {
  await initClient()

	const store = new PartSearchResultsDataStore()

	await store.fetch(params)

	return {
		PartSearchResultsData: store,
	}
}
